module.exports = __webpack_public_path__ + "assets/montserrat-bold.cba3c2238117520ff3f88ec32e8ca91192d51b605a2d0eeda296629ae6bd2c07.woff";